export default "__VITE_ASSET__CTOPRT6u__"